import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Users, Clock, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";

export function BecomeExpertSection() {
  return (
    <section className="py-16 bg-primary/5">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            Become an Expert Consultant
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Share your expertise with families who need guidance. Join our marketplace of verified care placement experts and help make a meaningful difference while setting your own rates.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <Card className="border-primary/20 bg-background/80 backdrop-blur-sm">
              <CardContent className="p-6 text-center">
                <Users className="h-8 w-8 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Help Families</h3>
                <p className="text-sm text-muted-foreground">
                  Guide families through complex care placement decisions with your expertise
                </p>
              </CardContent>
            </Card>

            <Card className="border-primary/20 bg-background/80 backdrop-blur-sm">
              <CardContent className="p-6 text-center">
                <Clock className="h-8 w-8 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Flexible Schedule</h3>
                <p className="text-sm text-muted-foreground">
                  Choose your own hours and availability to fit your lifestyle
                </p>
              </CardContent>
            </Card>

            <Card className="border-primary/20 bg-background/80 backdrop-blur-sm">
              <CardContent className="p-6 text-center">
                <DollarSign className="h-8 w-8 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Set Your Rates</h3>
                <p className="text-sm text-muted-foreground">
                  Determine your own pricing and earn compensation for your valuable time
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
            <Button asChild size="lg" className="w-full sm:w-auto">
              <Link to="/apply-expert">
                Apply to Become an Expert
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
              <Link to="/expert-marketplace-terms">
                Learn More About Requirements
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}